"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ComponentContainer = _interopRequireDefault(require("../../../../Framework/ComponentContainer"));
var _ServiceLocator = require("../../../ServiceLocator");
var _PdfDownload = _interopRequireDefault(require("../../Components/PdfDownload"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var mapStateToProps = function mapStateToProps(_ref) {
  var ui = _ref.ui,
    configurator = _ref.configurator;
  return {
    Component: _PdfDownload["default"],
    show: !!ui.visibilityMap.pdfDownload,
    code: configurator.configuration.code
  };
};
var mapDispatchToProps = function mapDispatchToProps() {
  return {
    onClose: function onClose() {
      return _ServiceLocator.Services.ui.hide('pdfDownload');
    },
    onOkClick: function onOkClick() {
      return _ServiceLocator.Services.ui.hide('pdfDownload');
    }
  };
};
var _default = exports["default"] = (0, _ComponentContainer["default"])(mapStateToProps, mapDispatchToProps);